import { Badge } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const CountBadge = styled(Badge)`
  .ant-badge-count {
    background-color: ${props => props.theme.colorFillSecondary};
    color: ${props => props.theme.colorText};
    font-weight: 600;
    box-shadow: none;
  }
`;

export interface ISubmissionMenuCountBadgeProps {
  count: number | undefined;
}

/**
 * Badge numerico mostrato a fine riga di una voce di menu (es. il numero di
 * allegati del modulo). Non renderizza nulla se il conteggio è assente o zero.
 */
export function SubmissionMenuCountBadge(
  props: ISubmissionMenuCountBadgeProps,
) {
  const { count } = props;
  const { t } = useTranslation();

  if (!count) return null;

  return (
    <>
      {/*
        Il conteggio è annunciato da un testo sr-only reale: l'`aria-label` sul
        Badge di Ant finirebbe su uno `span` senza role e alcuni screen reader
        lo ignorano. Il badge visivo è quindi marcato `aria-hidden`.
      */}
      <span className="sr-only">
        {t('submission-menu.count-badge.aria', '{{count}} allegati', {
          count,
        })}
      </span>
      <CountBadge count={count} overflowCount={99} aria-hidden="true" />
    </>
  );
}
